import { getCleanValue } from "Utils";
import { CatalogNode, SoftwareCatalogItem, SoftwarePopularity } from "./types";

export const getCountDetails = ([inCatalog, total]: number[]): string[] =>
  total === undefined
    ? [`${inCatalog} packages`]
    : [`${inCatalog} in catalog`, `${total} total`];

export const getBrowsableCount = (
  node: CatalogNode,
  canCurate: boolean,
): number => (canCurate && node.total !== null ? node.total : node.count);

const isTaken = (name: string, takenNames: string[]): boolean =>
  takenNames.map(getCleanValue).includes(getCleanValue(name));

const withSuffix = (
  name: string,
  takenNames: string[],
  suffix: number,
): string => {
  const candidate = `${name} (${suffix})`;

  return isTaken(candidate, takenNames)
    ? withSuffix(name, takenNames, suffix + 1)
    : candidate;
};

export const getUniqueName = (name: string, takenNames: string[]): string =>
  isTaken(name, takenNames) ? withSuffix(name, takenNames, 2) : name;

export const getPopularityAfterVote = (
  popularity: SoftwarePopularity,
  previousVote: SoftwareCatalogItem["user_like"],
  nextVote: SoftwareCatalogItem["user_like"],
): SoftwarePopularity => {
  const change = (vote: SoftwareCatalogItem["user_like"]): number =>
    (nextVote === vote ? 1 : 0) - (previousVote === vote ? 1 : 0);

  return {
    likes_count: popularity.likes_count + change(true),
    dislikes_count: popularity.dislikes_count + change(false),
  };
};
